import { generateFilterStateKey } from '@atlassian/notification-common';
import { ProductFilters, ReadState, RequestCategory, RequestReadState } from '@atlassian/notification-common/types';
import { getFilterStateOrDefaultByKey } from '../../../utils/build-filter-state';

/**
 * We now store all the notifications in the store so we can get into the state that going from UNREAD -> ALL
 * can display older UNREAD notifications before new ALL notifications load in between.
 *
 * Instead we want to filter the list so that we truncate from the lastNotificationId token.
 *
 * However if a list has not been loaded before then we want to display the skeleton to the user.
 */
export var truncateNotificationListById = function truncateNotificationListById(state, filters) {
  if (!filters) {
    return [];
  }
  var filterStateKey = generateFilterStateKey(filters);
  var filterState = getFilterStateOrDefaultByKey(state.filterStates, filterStateKey);

  /**
   * If a state category has not yet initialised, then don't show it to the user yet
   */
  if (!filterState.lastNotificationId) {
    return [];
  }
  var truncationIndex = filterState.lastNotificationId ? state.ids.findIndex(function (id) {
    return id === filterState.lastNotificationId;
  }) : -1;
  return truncationIndex > -1 ? state.ids.slice(0, truncationIndex + 1) : state.ids;
};
var getFilteredNotifications = function getFilteredNotifications(state, filters) {
  var notificationIds = truncateNotificationListById(state, filters);
  return notificationIds.reduce(function (acc, id) {
    var notification = state.notifications[id];
    if (!notification || filters.readStateFilter === RequestReadState.UNREAD && notification.readState !== ReadState.UNREAD || filters.categoryFilter === RequestCategory.DIRECT && notification.category !== RequestCategory.DIRECT || filters.categoryFilter === RequestCategory.WATCHING && !!notification.category) {
      return acc;
    }

    // TODO: We should not rely on the analytics key forever. We need a dedicated product key at the root
    if (filters.productFilter !== ProductFilters.ANY && filters.productFilter !== notification.analyticsAttributes.registrationProduct) {
      return acc;
    }
    acc.push(notification);
    return acc;
  }, []);
};
export { isGroupsMarkAllAsReadVisible } from './is-groups-mark-all-as-read-visible';
export default getFilteredNotifications;